import React from 'react';
import { Layout, Typography } from 'antd';

const { Content } = Layout;

interface SubPageLayoutProps {
  children: React.ReactNode;
  title?: string;
}

export const SubPageLayout: React.FC<SubPageLayoutProps> = ({ children, title }) => {
  return (
    <Layout style={{ padding: '8px' }}>
      <Typography.Title level={5}>{title}</Typography.Title>
      <Content
        style={{
          display: 'flex'
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            width: '100%'
          }}
        >
          {children}
        </div>
      </Content>
    </Layout>
  );
};
